import React from 'react';
import DepartmentActions from 'actions/DepartmentActions.js';
import LocationActions from 'actions/LocationActions.js';

export default class ShiftDetailBlock extends React.Component {
  constructor(props) {
    super(props);

    this.onLocationData = this.onLocationData.bind(this);
    this.onDepartmentData = this.onDepartmentData.bind(this);

    this.state = {
      id: '',
      title: '',
      time: '',
      department: {},
      location: {},
      position: {},
      department_id: null,
      location_id: null,
      notes: null,
    };

    this._isMounted = false;
  }

  componentDidMount() {
    this._isMounted = true;
    DepartmentsStore.on('load:success', this.onDepartmentData);
    LocationStore.on('load:success', this.onLocationData);

    if (this.props.locationID && this.props.departmentID) {
      this.state.location_id = this.props.locationID;
      this.state.department_id = this.props.departmentID;
      this.populateLocationAndDepartment(this.props.locationID, this.props.departmentID);
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
    DepartmentsStore.off('load:success', this.onDepartmentData);
    LocationStore.off('load:success', this.onLocationData);
  }

  populateLocationAndDepartment(locationId, departmentId) {
    if (departmentId) {
      DepartmentActions.getDepartment(departmentId, this);
    }

    if (locationId) {
      LocationActions.getLocation(locationId, this);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.departmentID != this.props.departmentID
      || nextProps.locationID != this.props.locationID
    ) {
      this.setState({
        id: nextProps.shiftId,
        department: nextProps.department,
        location: nextProps.location,
        position: {
          name: nextProps.position,
        },
        title: nextProps.title,
        time: nextProps.time,
      });

      this.state.location_id = nextProps.locationID;
      this.state.department_id = nextProps.departmentID;
      this.populateLocationAndDepartment(nextProps.locationID, nextProps.departmentID);
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
    LocationStore.off(null, null, this);
    DepartmentsStore.off(null, null, this);
  }

  onDepartmentData(data, response, target) {
    const departmentData = response.data || response;
    if (this.state.department_id == departmentData.id && target == this) {
      const locationID = departmentData.location_id;
      this.setState({
        department: departmentData,
      });
      // also get the location
      const location = LocationStore.getLocationById(locationID);
      if (!_.isEmpty(location)) {
        LocationStore.trigger('load:success', location, location, this);
      }
    }
  }

  onLocationData(data, response, target) {
    if (!Utils.isNotDefined(response) && target == this) {
      const locationData = response.data;
      this.setState({ location: locationData });
    }
  }

  render() {
    const selectedPosition = this.props.position != null ? this.props.position : '';
    const selectedJobSiteName = this.props.job_site_name != null ? this.props.job_site_name : '';
    const selectedJobSiteAddress = this.props.job_site_address != null ? this.props.job_site_address : '';
    const department = !_.isEmpty(this.state.department) ? this.state.department.name : '';
    const location = !_.isEmpty(this.state.location) ? this.state.location.name : '';
    const time = this.props.time ? this.props.time : '';
    const title = this.props.title ? this.props.title : '';
    const notes = this.props.shift_notes;

    return (
      <p id="shift-details">
        <span id="shift-title">{title}</span>
        <span id="shift-time">{time}</span>
        <span id="shift-location">{location}</span>
        <span id="shift-departments">{department}</span>
        <span id="shift-job-site-name">{selectedJobSiteName}</span>
        <span id="shift-job-site-address">{selectedJobSiteAddress}</span>
        <span id="shift-position">{selectedPosition}</span>
      </p>
    );
  }
}
